import dateFns from 'date-fns';
import * as TerrassorConst from '../../../../terrassor_const.js'
import { set_Terrassor_INTERFACE, get_Terrassor_INTERFACE, Terrassor_RECALCULATE } from "../../../../interface.js";

/* @ngInject */
export class DescriptionChantierController {
    /* @ngInject */
    constructor (ApiConst, ApiSimu, ApiExo, $scope, $filter) {
      this.ApiConst = ApiConst
      this.ApiSimu = ApiSimu
      this.ApiExo = ApiExo
      this.$scope = $scope
      this.$filter = $filter

      //this.onResourceChange = this.onResourceChange.bind(this)

      //this.$scope.$watch('DescriptionChantierController.resource', this.onResourceChange)

      this.dateFormatFR = 'DD/MM/YYYY'

      this.initEnCours = false
      this.dateDebut = ''
      this.dateFin = ''
      this.dateDebutInit = ''
      this.simuexo = this.initialiserDescriptionChantier()
      TerrassorConst.chantierId = this.simuexo.id // une fois pour toutes - en mode création, l'id du chantier est toujours "-1"
    }

    /*
    * Format à l'américaine --> datePicker !!!
    */
    datePourPicker(laDate) {
        var ddc =  new Date(laDate);
        var mois = ("0" + (ddc.getMonth() + 1)).slice(-2);
        var jour = ("0" + ddc.getDate()).slice(-2);
        return(mois+"/"+jour+"/"+ddc.getFullYear());
    }

    $onChanges  (obj) {
        var ttot = obj;
        var titi = 1;
    }

    $onInit () {

    console.log('DescriptionChantierController : init')

        this.initEnCours = true;
    //     this.simuexo = new Object()
      this.simuexoHumidites = []

        this.ApiSimu.getConstHumidites()
            .then(resultArray => {
                 resultArray.forEach(item => {
                    if (item.nom.length) {
                        this.simuexoHumidites[this.simuexoHumidites.length] = item;
                        }
                    });

                this.ApiSimu.getSimuExoChantier()
                    .then(resultArray => {
                        var simuexo = resultArray.pop()
                        if (typeof(simuexo) !== 'undefined') {
                            this.simuexo = simuexo;
                            this.parentSimulator.simuExo_Chantier = simuexo;
                            this.isCheckReadOnly();
                        }
                    /* Déjà fait par défaut
                        else {
                            this.simuexo = this.initialiserDescriptionChantier()
                        }
                    */

                    this.setDate()


                    // this.parentSimulator.autoriserVisualisations(); // etre sur de l'état

//        this.$timeout(() => {this.$scope.$broadcast('OPENPANEL', { id: idPanel })}, 500);
                    this.parentSimulator.$timeout(() => {this.$scope.$apply()}, 500);
                    })
            })

/*
        // BC 2018/02 limitation au début du chantier - fait une fois pour toute pour tous les mouvements
        this.debutPossible =   this.datePourPicker(this.parentSimulator.getCurrentChantier().debut);
        this.liberationDebutPossible =  this.debutPossible; // la deuxième date - modifiée de façon dynamique plus tard


        // BC 09/17 - il faut aussi que le mouvement puisse accéder à sa description !!!
      let hasResource = Boolean(this.resource)
      if(!hasResource)
        return

      this.currentMouvement = this.resource
      this.exoMouvement = this.currentMouvement.exoMouvement;
      this.simuMouvement = this.currentMouvement.simuMouvement;


      */
    }

    initialiserDescriptionChantier() {

        this.checkIsReadOnly = true;

        var descriptionObj = new Object()
        descriptionObj.id = -1
        descriptionObj.code = "EPUR"
        descriptionObj.nom = ""
        descriptionObj.exo_chantiers_groupe_id = 0
        descriptionObj.alea_group_id = 0
        descriptionObj.kmdebut = 0
        descriptionObj.longueur = 1
        descriptionObj.const_humidite_id = ""
        descriptionObj.efficience = 80
        descriptionObj.debut = ""
        descriptionObj.delai = ""
        descriptionObj.budget = ""
        descriptionObj.vitessemax = ""
        descriptionObj.stopautomatiqsimu_1 = 0
        descriptionObj.stopautomatiqsimu_2 = 0
        descriptionObj.description = ""
        descriptionObj.valid = 1
        descriptionObj.is_publiable = 1
        descriptionObj.created = ""
        descriptionObj.modified = ""
        descriptionObj.created_by = ""
        descriptionObj.modified_by = ""
        return(descriptionObj)
    }

    /*
    * sauvegarde : dès qu'un champ est modifé
    */
    save () {
        if (this.initEnCours) { // le save est lancé à l'init des donnée, on ne veut pas décocher à ce moment là
            this.initEnCours = false;
        }
        else {
            this.parentSimulator.doOnCheckParametrageChantierValid(false);
        }
        this.isCheckReadOnly();

        // on met à jour le chantier
        return this.ApiSimu.saveSimuExoChantier(this.simuexo)
            .then(chantier => {
                this.parentSimulator.simuExo_Chantier = chantier;
            });
    }

    saveDebut () {
        this.isCheckReadOnly();
    }

    isCheckReadOnly() {
        var simuexo = this.simuexo;
        if ( (simuexo.nom == "") || (simuexo.longueur == 0) || (simuexo.const_humidite_id == "") || (simuexo.debut == "") || (simuexo.delai == "") || (simuexo.budget == "") || (simuexo.vitessemax == "")
            // test sur les min / max
            || (simuexo.kmdebut < 0) || (simuexo.kmdebut > 999999) || (simuexo.longueur < 1) || (simuexo.longueur > 5000) || (simuexo.efficience < 30) || (simuexo.efficience > 100)
            || (simuexo.delai < 1) || (simuexo.delai > 250) || (simuexo.budget < 1) || (simuexo.budget > 99999999)  || (simuexo.vitessemax < 30) || (simuexo.vitessemax > 90)
            || (typeof(simuexo.debut) == 'undefined') || (typeof(simuexo.kmdebut) == 'undefined') || (typeof(simuexo.longueur) == 'undefined') || (typeof(simuexo.vitessemax) == 'undefined') || (typeof(simuexo.efficience) == 'undefined') || (typeof(simuexo.delai) == 'undefined') || (typeof(simuexo.budget) == 'undefined') ) {
                this.checkIsReadOnly = true;
                if (this.parentSimulator.etapeParametrageChantierValide) {
                    this.parentSimulator.doOnCheckParametrageChantierValid(false);
                }
            }
        else {
            this.checkIsReadOnly = false;
        }

        return(this.checkIsReadOnly);
    }


/*
* init champs input dates
* ! modif RA 17.03.08. Plus de date par défaut au 1er accès mouvement
*/
    setDate() {

        var debut = this.simuexo.debut;
        if(debut) {
            var dateTmp = dateFns.format(debut, this.dateFormatFR)
            this.dateDebut = this.convert_FR_EN(dateTmp)
            this.dateDebutInit = this.dateDebut
            /*if (this.simuexo.delai) {
                var periode = new PERIODE();
                var dateFin = periode.ajouterEnJourOuvres(debut, this.simuexo.delai);
                this.dateFin = dateFns.format(dateFin, this.dateFormatFR)
            }*/
        //this.beginCalendar = dateFns.parse(this.convert_FR_EN(this.beginningDate)).toISOString() // au format ISO pour l'init du calendar
        }
    }



    /* BC ma propre fonction de date à cause de la bidouille qui rajoute 1 heure dans le code angular et dont je ne veux pas */
    /*
	dateChaine = function(laDate) {
        var lesMois = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
        var num=laDate.getDate();
        if (num < 10) {
            num = "0"+num;
        }
        else {
            num = ""+num;
        }
        var mois=lesMois[laDate.getMonth()];
        var an=laDate.getFullYear();
        return(""+num+'/'+mois+'/'+an);
    }
*/

  /*
  *
  */
    changeDate(dateImposee) {
        var pasBon;

        /* BC 09/2017  - on peut vouloir imposer une date
        if (typeof(dateImposee) != 'undefined') {
            this.simuexo.debut = this.dateChaine(dateImposee)
        }
         fin BC */
        var dateDebut = this.dateDebut;
        if (dateDebut.length != 10) {
            this.simuexo.debut = pasBon; // undefined
            $( "#dchantierdebut" ).addClass( "invalidation" );
            this.isCheckReadOnly();
            return
        }
        var debut = dateFns.parse(this.convert_FR_EN(dateDebut))
        if(!dateFns.isValid(debut)) {
            this.simuexo.debut = pasBon; // undefined
            $( "#dchantierdebut" ).addClass( "invalidation" );
            this.isCheckReadOnly();
            return
        }
        this.simuexo.debut = debut;
            $( "#dchantierdebut" ).removeClass( "invalidation" );

        if (this.simuexo.delai) {
            var periode = new PERIODE();
            var dateFin = periode.ajouterEnJourOuvres(debut, this.simuexo.delai);
            this.dateFin = dateFns.format(dateFin, this.dateFormatFR)
        }
        this.isCheckReadOnly();
        this.save();
    }
    changeDelai() {

        //var laFin = periode.ajouterEnJourOuvres(new Date(this.dateDebut), this.etude.chantier.delai);
        if (this.dateDebut.length == 10) {
            var periode = new PERIODE();
            var dateFin = periode.ajouterEnJourOuvres(this.simuexo.debut, this.simuexo.delai);
            this.dateFin = dateFns.format(dateFin, this.dateFormatFR)
        }
        this.save();
    }

    convert_FR_EN (dateFR) {
      let [day, month, year] = dateFR.split('/')
      let dateEN = `${month}/${day}/${year}`
      return dateEN
    }

/**************************************************************************************************************************************************/
                    /* DESSOUS : A CONSERVER OU PAS */
/**************************************************************************************************************************************************/


    /*
    onResourceChange (newResource, oldResource) {
var toto = newResource
var tito = oldResource
    }
*/



/*
    getMaxLimitDate () {
      if(!this.currentMouvement)
         return null
      var simuMouvement = this.currentMouvement.simuMouvement
      console.log('DescriptionChantierController::getMaxLimitDate', simuMouvement, this.endingDate)

      return dateFns.parse(this.convert_FR_EN(simuMouvement.fin)).toUTCString()
    }

    getMinLimitDate () {
      if(!this.currentMouvement)
         return null
      var simuMouvement = this.currentMouvement.simuMouvement
      return dateFns.parse(this.convert_FR_EN(simuMouvement.debut)).toUTCString()
    }
*/


}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/description-chantier/description-chantier.controller.js